import React from 'react';
import styled from 'styled-components';

import withParallax from 'utils/parallax';
import { media } from 'utils/detection';

const Link = withParallax(styled.a`
  color: ${props => props.theme.textSemiDark};
  font-family: 'Galano Classic';
  font-size: 13px;
  font-weight: 500;
  line-height: 26px;
  padding: 0;
  margin: 0;
  text-decoration: none;

  ${media.medium`
    font-size: 1.4vw;
    line-height: 2.4vw;
  `}

  ${media.large`
    font-size: 1vw;
    line-height: 2vw;
  `}
`);

export default class StyledLink extends React.Component {
  render() {
    return <Link {...this.props} />;
  }
}
